import React, {useState, useEffect} from 'react';

import PropTypes from 'prop-types';


const Pagination = (props) => {
	const [pages, setPages] = useState([1]);
	useEffect(() => {
		var arr = [];
		for(var i = props.start_num; i <= props.end_num ; i++) {
			arr.push(i);
		}
		setPages(arr);
    }, [props]);

	const changePage = (page) => {
        if(page < 1) page = 1;
        if(page != props.page && page > 0 && page <= props.last_page) {
            if(props.callback) props.callback(page);
        }
	}

	return (
		<nav aria-label="Page navigation example">
            <ul className="pagination">
                <li className="page-item">
                    <a className="page-link" onClick={() => changePage(props.start_num -1)} aria-label="Previous">
                        <span aria-hidden="true">«</span><span className="sr-only">Previous</span>
                    </a>
                </li>
                {
                	pages.map(p => {
                		return (
                			<li key={p} className={p === props.page ? 'page-item active' : 'page-item'}>
                				<a className={p === props.page ? 'page-link active' : 'page-link'} onClick={() => changePage(p)}>{p}</a>
                			</li>
                		)
                	})
                }
                <li className="page-item">
                    <a className="page-link" onClick={() => changePage(props.last_page == props.end_num ? props.last_page : props.end_num+1)}  aria-label="Next"><span aria-hidden="true">»</span>
                       <span className="sr-only">Next</span></a>
                </li>
            </ul>
        </nav>
	)

}

Pagination.propTypes = {
  page : PropTypes.number,
  start_num : PropTypes.number,
  end_num : PropTypes.number,
  last_page : PropTypes.number,
  callback : PropTypes.func
};


export default Pagination;
